import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import logo from "@/assets/logo_salone_vincente.png";
import { YouTubePlayer } from "@/components/YouTubePlayer";

const VideoIntro = () => {
  const [showButton, setShowButton] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleTimeRemaining = (seconds: number) => {
    if (seconds <= 10 && seconds > 0 && !showButton) {
      setShowButton(true);
    }
  };

  const handleNext = () => {
    const queryString = searchParams.toString();
    navigate(`/2${queryString ? `?${queryString}` : ''}`);
  };

  return (
    <div className="h-screen gradient-subtle flex flex-col p-4">
      {/* Contenuto principale centrato */}
      <div className="flex-1 flex items-center justify-center">
        <div className="max-w-5xl w-full flex flex-col">
          {/* Header orizzontale con logo e titolo */}
          <div className="flex items-center gap-4 mb-3 animate-fade-in">
            <img 
              src={logo} 
              alt="Salone Vincente" 
              className="w-16 h-16 object-contain animate-float flex-shrink-0" 
            />
            <h1 className="flex-1 text-center text-xl md:text-2xl font-bold bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent">
              BENVENUTO NELL'ONBOARDING DI SALONE VINCENTE
            </h1>
          </div>

          {/* Video Container */}
          <div className="relative card p-3 shadow-elegant animate-slide-up">
            <YouTubePlayer 
              videoId="RUHTV1pBZGY" 
              onTimeRemaining={handleTimeRemaining}
              showButtonAt={10}
            />

            {/* Button */}
            {showButton && (
              <div className="mt-4 flex justify-center animate-fade-in">
                <Button 
                  onClick={handleNext} 
                  size="lg" 
                  className="bg-gradient-to-r from-primary to-secondary hover:opacity-90 transition-opacity px-8"
                >
                  Continua al prossimo step dell'onboarding
                  <ChevronRight className="w-5 h-5 ml-2" />
                </Button>
              </div>
            )}
          </div>

          {/* Footer */}
          {!showButton && (
            <div className="text-center mt-3 text-base md:text-lg font-semibold text-foreground animate-pulse">
              <p>Guarda il video per continuare</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoIntro;
